export type TTimeInputParsedValue = {
  hours24: string;
  minutes: string;
  displayHours: string;
  dayTime: 'AM' | 'PM';
};

export const parseTimeInputValue = (value: string): TTimeInputParsedValue => {
  const safeValue = value || '12:00';
  const hours24 = safeValue.split(':')[0] ?? '12';
  const minutes = safeValue.split(':')[1] ?? '00';
  const hoursNumber = parseInt(hours24, 10);
  const dayTime = hoursNumber > 11 ? 'PM' : 'AM';

  let displayHours = hours24;
  if (hoursNumber === 0) {
    displayHours = '12';
  } else if (hoursNumber < 13) {
    displayHours = hours24;
  } else {
    displayHours = (hoursNumber - 12).toString();
    if (displayHours.length === 1) {
      displayHours = `0${displayHours}`;
    }
  }

  return { hours24, minutes, displayHours, dayTime };
};
